import React from 'react';
import './Footer.css';
import EnhancedLogo from './EnhancedLogo';

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-section">
          <div className="footer-logo-container">
            <EnhancedLogo size="medium" />
          </div>
          <p>Empowering businesses with innovative technology solutions and exceptional talent.</p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li><a href="#services">Software Development</a></li>
            <li><a href="#services">IT Consultancy</a></li>
            <li><a href="#services">Staffing Solutions</a></li>
            <li><a href="#services">Team Augmentation</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact Info</h4>
          <ul>
            <li>📧 info@codersping.com</li>
            <li>📞 +91 9415273591</li>
            <li>📍 Lucknow & Noida, India</li>
          </ul>
          <div className="footer-social">
            <h4>Connect With Us</h4>
            <a href="https://www.linkedin.com/company/codersping-infotech" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <span className="social-icon-linkedin">in</span> LinkedIn
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>&copy; 2026 CodersPing InfoTech. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
